import { InjectionToken } from '@angular/core';

import { BackendLoader } from './api-env';
import { EnvironmentEnum } from './enums';

export const API_ENVIRONMENT = new InjectionToken<EnvironmentEnum>('API_ENVIRONMENT');
export const API_BACKENDS = new InjectionToken<Record<EnvironmentEnum, BackendLoader>>('API_BACKENDS');
